import {UI} from "../../../../../stem-core/src/ui/UIBase";

import {BasePanel, BasePanelStyle} from "../BasePanel";
import {PurchaseFlowController} from "../../../flows/PurchaseFlowController";
import {iFrameMerchantService} from "../../../../services/IframeMerchantService";
import {Money} from "../../../../../client/state/misc/Money";
import {Messages} from "../../../../Messages";
import {styleRule} from "../../../../../stem-core/src/decorators/Style";
import {isSmallScreen} from "../../../../UtilsLib";
import {registerStyle} from "../../../../../stem-core/src/ui/style/Theme";
import {MessageElement} from "../../../../widget/ui/MessageElement";


class PaymentPanelStyle extends BasePanelStyle {
    @styleRule
    secondaryMessage = {
        ...this.themeProps.PAYWALL_MESSAGE_STYLE,
        lineHeight: () => (isSmallScreen() ? 23 : 26),
        marginTop: 12,
        marginBottom: 0,
        fontSize: () => isSmallScreen() ? 15 : 16
    };
}

@registerStyle(PaymentPanelStyle)
export class PaymentPanel extends BasePanel {
    getControllerClass() {
        return PurchaseFlowController;
    }

    renderDefaultFooter() {
        const {styleSheet} = this;
        const signupCreditCurrency = iFrameMerchantService.getMerchant().getCurrency();
        const signupCredit = new Money(signupCreditCurrency.getSettings().signupCredit, signupCreditCurrency);

        return [
            <MessageElement message={Messages.paywallBottomMessage(signupCredit)}
                            className={styleSheet.secondaryMessage} />,
            super.renderDefaultFooter()
        ];
    }
}
